import type { GitHubConfig } from '../types';

/** Same-origin proxy URL so the video element can use HTTP Range on mobile. */
export function githubMediaProxyUrl(config: GitHubConfig, repoPath: string): string {
  const params = new URLSearchParams({
    owner: config.owner,
    repo: config.repo,
    branch: (config.branch?.trim() || 'main'),
    path: repoPath.replace(/^\//, ''),
    access_token: config.pat,
  });
  return `/api/github-media?${params}`;
}
